import KeenSlider from "keen-slider"

if (!customElements.get("ia-synced-slider")) {
  class IASyncedSlider extends HTMLElement {
    constructor() {
      super()
      this.imageSlider = null
      this.cardSlider = null
      this.prevButtons = null
      this.nextButtons = null
      this.syncing = false

      // elements inside this component
      this.imageSliderEl = this.querySelector(".ia-synced-slider__images .keen-slider")
      this.cardSliderEl  = this.querySelector(".ia-synced-slider__cards .keen-slider")

      // config via attributes
      this.loop = this.dataset.loop === "true"
    }

    connectedCallback() {
      this.init()
    }

    disconnectedCallback() {
      this.destroy()
    }

    init() {
      if (!this.imageSliderEl || !this.cardSliderEl) {
        console.warn("[ia-synced-slider] Missing slider elements")
        return
      }

      // arrows live INSIDE <ia-synced-slider>, but OUTSIDE the .keen-slider elements
      this.prevButtons = this.querySelectorAll(".js-ia-slider-prev")
      this.nextButtons = this.querySelectorAll(".js-ia-slider-next")

      // create sliders (1 per view, horizontal)
      this.imageSlider = new KeenSlider(this.imageSliderEl, {
        loop: this.loop,
        slides: { perView: 1, spacing: 20 },
        drag: false,
        created: () => this.classList.remove("is-loading")
      })

      this.cardSlider = new KeenSlider(this.cardSliderEl, {
        loop: this.loop,
        slides: { perView: 1, spacing: 20 },
        drag: false,
      })

        // two-way sync
        this._isSyncing = false

        const link = (from, to) => {
            from.on("animationStarted", (s) => {
                if (this._isSyncing) return
                this._isSyncing = true

                // get the absolute target the 'from' slider is animating to
                const nextAbs = s.animator.targetIdx ?? s.track.details.abs
                // convert it to a relative index for the 'to' slider (handles loop wrap)
                const targetRel = to.track.absToRel(nextAbs)

                to.moveToIdx(targetRel)
            })

            to.on("animationEnded", () => {
                // release the lock ONLY after the destination slider is done
                this._isSyncing = false
                this.updateArrows(this.currentIndex())
            })
        }

        link(this.imageSlider, this.cardSlider)
        link(this.cardSlider, this.imageSlider)

      // arrows inside the element
      this.prevButtons?.forEach((btn) => btn.addEventListener("click", this.prev))
      this.nextButtons?.forEach((btn) => btn.addEventListener("click", this.next))

      // set initial arrow state
      this.updateArrows(this.currentIndex())
    }

    // helpers
    currentIndex() {
      return this.imageSlider?.track?.details?.rel ?? 0
    }

    updateArrows(activeIndex) {
      // hide prev at first slide; hide next at last slide when not looping
      if (!this.imageSlider) return
      const last = this.imageSlider.slides.length - 1

      this.prevButtons?.forEach((b) => {
        if (!this.loop && activeIndex === 0) b.classList.add("disabled")
        else b.classList.remove("disabled")
      })

      this.nextButtons?.forEach((b) => {
        if (!this.loop && activeIndex === last) b.classList.add("disabled")
        else b.classList.remove("disabled")
      })
    }

    // public controls
    next = () => {
      this.imageSlider?.next() // card slider follows via sync
    }
    prev = () => {
      this.imageSlider?.prev()
    }
    goTo = (index) => {
      this.imageSlider?.moveToIdx(index)
    }

    destroy() {
      this.prevButtons?.forEach((btn) => btn.removeEventListener("click", this.prev))
      this.nextButtons?.forEach((btn) => btn.removeEventListener("click", this.next))
      this.imageSlider?.destroy()
      this.cardSlider?.destroy()
      this.imageSlider = null
      this.cardSlider = null
    }
  }

  customElements.define("ia-synced-slider", IASyncedSlider)
}
